// import axios from "axios";
// import { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import "./SchoolEditClass.css";

// const SchoolEditClass = () => {
//   const [schoolClassEdit, setSchoolClassEdit] = useState("");
//   const [category, setCategory] = useState([]);
//   const [selectCategory, setSelectCategory] = useState("");

//   const { id } = useParams();
//   const navigate = useNavigate();

//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/classes/${id}`)
//       .then((response) => {
//         const { data } = response.data;
//         setSchoolClassEdit(data?.className);
//         setCategory(data?.category || []);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   }, []);

//   const handleAddCategory = () => {
//     if (selectCategory && !category.includes(selectCategory)) {
//       setCategory([...category, selectCategory]);
//       setSelectCategory(""); // reset dropdown
//     }
//   };

//   const handleRemoveCategory = (cat) => {
//     setCategory(category.filter((item) => item !== cat));
//   };

//   let handleEditSave = () => {
//     axios
//       .put(`${API_BASE_URL}/classes/${id}`, {
//         className: schoolClassEdit,
//         category,
//       })
//       .then((resp) => {
//         // window.location.reload("/school-all-class");
//         alert("Data Updated Successfully");
//         navigate("/school-all-class");
//       })
//       .catch((err) => {
//         alert("Error", err);
//       });
//     navigate("/school-all-class");
//   };

//   const handleAddNewClass = () => {
//     navigate("/school-add-class");
//   };

//   const handleViewAllClasses = () => {
//     navigate("/school-all-class");
//   };

//   const handleEdit = (e) => {
//     setSchoolClassEdit(e.target.value);
//   };

//   return (
//     <>
//       <div id="add-department-inner-wrapper">
//         <div className="superheader">
//           <div className="departmetHeaderdiv">
//             <h5>Edit Class</h5>
//             <div className="departmentdiv2">
//               <button className="handlenewclass" onClick={handleAddNewClass}>
//                 + Add New Class
//               </button>
//               <button className="allclasses" onClick={handleViewAllClasses}>
//                 All Classes
//               </button>
//             </div>
//           </div>

//           <div className="form-school-container">
//             <h4 className="department-detail">Class Details</h4>
//             <form onSubmit={handleEditSave} className="department-detail-form">
//               <div className="input-group">
//                 <div style={{ paddingBottom: "10px" }}>
//                   <label className="label"> Class Name</label>
//                 </div>
//                 <input
//                   style={{
//                     marginLeft: "1px",
//                     borderBottomLeftRadius: "5px",
//                     borderTopLeftRadius: "5px",
//                   }}
//                   type="text"
//                   value={schoolClassEdit}
//                   onChange={handleEdit}
//                   placeholder="Enter Class Name"
//                   required
//                 />
//               </div>
//               <div className="input-group">
//                 <div style={{ paddingBottom: "10px" }}>
//                   <label className="label">Select Category</label>
//                 </div>
//                 <div style={{ display: "flex", gap: "10px" }}>
//                   <select
//                     className="school-class-add-input-tag"
//                     value={selectCategory}
//                     onChange={(e) => setSelectCategory(e.target.value)}
//                   >
//                     <option value="">-Select Category-</option>
//                     <option
//                       value="Exam_Notes"
//                       disabled={category.includes("Exam_Notes")}
//                     >
//                       Exam Notes
//                     </option>
//                     <option
//                       value="Subjective_Exam"
//                       disabled={category.includes("Subjective_Exam")}
//                     >
//                       Subjective Exam
//                     </option>
//                     <option
//                       value="video_section"
//                       disabled={category.includes("video_section")}
//                     >
//                       Video Section 
//                     </option>
//                   </select>
//                   <button
//                     type="button"
//                     onClick={handleAddCategory}
//                     className="btn-s"
//                   >
//                     Add
//                   </button>
//                 </div>
//               </div>

//               {/* Show selected categories with remove option */}
//               {category.length > 0 && (
//                 <div className="selected-categories">
//                   <p style={{ marginBottom: "5px" }}>Selected Categories:</p>
//                   <ul>
//                     {category.map((cat, index) => (
//                       <li key={index} style={{ marginBottom: "5px" }}>
//                         {cat.replaceAll("_", " ")}
//                         <button
//                           type="button"
//                           onClick={() => handleRemoveCategory(cat)}
//                           style={{
//                             marginLeft: "10px",
//                             background: "red",
//                             color: "white",
//                             border: "none",
//                             padding: "2px 6px",
//                             borderRadius: "4px",
//                             cursor: "pointer",
//                           }}
//                         >
//                           Remove
//                         </button>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//               <div className="form-school-btns">
//                 <button className="btn-s" type="save">
//                   Save
//                 </button>
//                 <button className="btn-c" type="cancel">
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default SchoolEditClass;







import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import "./SchoolEditClass.css";

const SchoolEditClass = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [schoolClassEdit, setSchoolClassEdit] = useState("");
  const [boards, setBoards] = useState([]);
  const [selectedBoard, setSelectedBoard] = useState("");
  const [category, setCategory] = useState([]);
  const [selectCategory, setSelectCategory] = useState("");

  /* ================= FETCH BOARDS + CLASS DATA ================= */

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch Boards
        const boardRes = await axios.get(
          `${API_BASE_URL}/boards`,
          {
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        setBoards(boardRes.data.data || []);

        // Fetch Single Class
        const classRes = await axios.get(
          `${API_BASE_URL}/classes/${id}`,
          {
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        const classData = classRes.data.data;

        setSchoolClassEdit(classData?.className);
        setSelectedBoard(classData?.board?._id || classData?.board);
        setCategory(classData?.category || []);

      } catch (error) {
        Swal.fire("Error", "Failed to fetch data", "error");
      }
    };

    fetchData();
  }, [id]);

  /* ================= CATEGORY HANDLING ================= */

  const handleAddCategory = () => {
    if (selectCategory && !category.includes(selectCategory)) {
      setCategory([...category, selectCategory]);
      setSelectCategory("");
    }
  };

  const handleRemoveCategory = (cat) => {
    setCategory(category.filter((item) => item !== cat));
  };

  /* ================= UPDATE CLASS ================= */

  const handleEditSave = async (e) => {
    e.preventDefault();

    if (!selectedBoard) {
      return Swal.fire("Warning", "Please select board", "warning");
    }

    if (category.length === 0) {
      return Swal.fire(
        "Warning",
        "Please select at least one category",
        "warning"
      );
    }

    try {
      await axios.put(
        `${API_BASE_URL}/classes/${id}`,
        {
          className: schoolClassEdit,
          board: selectedBoard,
          category,
        },
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      await Swal.fire(
        "Success",
        "Class updated successfully!",
        "success"
      );

      navigate("/school-all-class");

    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.msg ||
          "Failed to update class",
        "error"
      );
    }
  };

  return (
    <div id="add-department-inner-wrapper">
      <div className="superheader">
        <div className="departmetHeaderdiv">
          <h5>Edit Class</h5>
        </div>

        <div className="form-school-container">
          <h4 className="department-detail">Class Details</h4>

          <form
            onSubmit={handleEditSave}
            className="department-detail-form"
          >

            {/* CLASS NAME */}
            <div className="input-group">
              <label className="label">Class Name</label>
              <input
                type="text"
                value={schoolClassEdit}
                onChange={(e) =>
                  setSchoolClassEdit(e.target.value)
                }
                placeholder="Enter Class Name"
                required
              />
            </div>

            {/* BOARD DROPDOWN */}
            <div className="input-group">
              <label className="label">Select Board</label>
              <select
                value={selectedBoard}
                onChange={(e) =>
                  setSelectedBoard(e.target.value)
                }
                required
              >
                <option value="">-Select Board-</option>
                {boards.map((board) => (
                  <option key={board._id} value={board._id}>
                    {board.boardName}
                  </option>
                ))}
              </select>
            </div>

            {/* CATEGORY */}
            <div className="input-group">
              <label className="label">
                Select Category
              </label>

              <div style={{ display: "flex", gap: "10px" }}>
                <select
                  value={selectCategory}
                  onChange={(e) =>
                    setSelectCategory(e.target.value)
                  }
                >
                  <option value="">
                    -Select Category-
                  </option>

                  <option
                    value="Exam_Notes"
                    disabled={category.includes(
                      "Exam_Notes"
                    )}
                  >
                    Exam Notes
                  </option>

                  <option
                    value="Subjective_Exam"
                    disabled={category.includes(
                      "Subjective_Exam"
                    )}
                  >
                    Subjective Exam
                  </option>

                  <option
                    value="video_section"
                    disabled={category.includes(
                      "video_section"
                    )}
                  >
                    Video Section
                  </option>
                </select>

                <button
                  type="button"
                  onClick={handleAddCategory}
                  className="btn-s"
                >
                  Add
                </button>
              </div>
            </div>

            {/* SELECTED CATEGORY LIST */}
            {category.length > 0 && (
              <div className="selected-categories">
                <p>Selected Categories:</p>
                <ul>
                  {category.map((cat, index) => (
                    <li key={index}>
                      {cat.replaceAll("_", " ")}
                      <button
                        type="button"
                        onClick={() =>
                          handleRemoveCategory(cat)
                        }
                        className="remove-btn"
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* BUTTONS */}
            <div className="form-school-btns">
              <button
                className="btn-s"
                type="submit"
              >
                Save
              </button>

              <button
                className="btn-c"
                type="button"
                onClick={() =>
                  navigate("/school-all-class")
                }
              >
                Cancel
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default SchoolEditClass;
